export default (date) => {
  if (date) {
    return new Date(Date.parse(date.replace(/-/g, '/'))).toLocaleString('es').slice(0, -3)
  } else {
    return date
  }
}
